module.exports = __webpack_public_path__ + "static/media/manu-3.c88c0f6d.png";